import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/inicio', documento: 'raiz', acceso: 'publico', filas: ['153', '019'],
  cita: 'Controllers/AccountController.cs:198',
  // Views/Account/Login.cshtml:6-7 (2dcbb888): sin jQuery ni lodash y estilos acotados a body.login-cuerpo.
  viewBag: { sinJquery: true, claseCuerpo: 'login-cuerpo' },
} satisfies RutaProd;
